import React from "react";
import ApproveGlobal from "../../../components/datagrid/EmployeeService/PostWorkingHours/ApproveGlobal";
import {
  approveQuotation,
  getQuotationRequirements,
  getQuotationsOfRequrements,
} from "../../../redux/features/assetManagementSlice";
import { useSelector } from "react-redux";

const ApproveQuotation = ({
  quotationId,
  requirementID,
  isClosed,
  dispatchParams,
  isApproval,
}) => {

  const { loading } = useSelector((store) => store.assetmanagement);
  return (
    <ApproveGlobal
      statusChangeApiCall={approveQuotation(quotationId)}
      loading={loading}
      upDateCall={getQuotationRequirements(dispatchParams)}
      isDisabled={isClosed || isApproval}
      buttonName={"Approve"}
    />
  );
};

export default ApproveQuotation;
